import React from "react";
import { useTheme } from "../../contexts/ThemeContext";

const AppFeatures = () => {
    const { colors, isDark } = useTheme();

    const testimonials = [
        {
            text: "This application significantly contributed to our academic endeavors. It is an invaluable tool for academics",
            author: "Shashank Chaubey",
            rating: 5,
            role: "CU Student"
        },
        {
            text: "This app is the best. Way better than the official app. Hope you make more good things like this in the future.",
            author: "Prateek Singh",
            rating: 5,
            role: "CU Student"
        }
    ];

    return (
        <section
            id="about"
            className="relative py-20 px-6 overflow-hidden"
        >
            <div className="relative max-w-3xl mx-auto">
                {/* Section Header */}
                <div className="text-center mb-10">
                    <p className={`text-sm font-medium tracking-widest uppercase ${colors.textMuted} mb-2`}>
                        Testimonials
                    </p>
                    <h2 className={`text-2xl md:text-3xl font-semibold tracking-tight ${colors.text}`}>
                        Loved by students
                    </h2>
                </div>

                {/* Reviews — horizontal scroll on mobile, side-by-side on desktop */}
                <div className="flex gap-5 overflow-x-auto snap-x snap-mandatory scrollbar-hide pb-2 md:grid md:grid-cols-2 md:overflow-visible">
                    {testimonials.map((testimonial, index) => (
                        <div
                            key={index}
                            className={`flex-shrink-0 w-[85%] snap-center md:w-auto rounded-2xl p-6 border transition-colors duration-200 ${
                                isDark
                                    ? 'bg-white/[0.03] border-white/[0.06] hover:bg-white/[0.05]'
                                    : 'bg-gray-50/80 border-gray-200/60 hover:bg-gray-100/80'
                            }`}
                        >
                            {/* Stars — small, inline */}
                            <div className="flex gap-0.5 mb-4">
                                {[...Array(testimonial.rating)].map((_, i) => (
                                    <svg key={i} className="w-4 h-4 text-amber-400" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"/>
                                    </svg>
                                ))}
                            </div>

                            <p className={`text-base leading-relaxed ${colors.textSecondary} mb-5`}>
                                "{testimonial.text}"
                            </p>

                            <div className="flex items-center gap-3">
                                <div className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-semibold ${
                                    isDark ? 'bg-white/10 text-white' : 'bg-gray-200 text-gray-700'
                                }`}>
                                    {testimonial.author.charAt(0)}
                                </div>
                                <div>
                                    <div className={`text-sm font-medium ${colors.text}`}>
                                        {testimonial.author}
                                    </div>
                                    <div className={`text-xs ${colors.textMuted}`}>
                                        {testimonial.role}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default AppFeatures;
